import { Turbo } from "@hotwired/turbo-rails"

// Every `data-turbo-confirm` in the app, asked in our own modal instead of the
// browser's system dialog — which is grey, says "voyage-prive.wannacollab.dev
// says" over the question and cannot be dressed (9 Sep 2026).
//
// The message carries both lines: the question up to its "?" becomes the
// title, whatever follows is the sentence under it ("Cancel this collab?
// Mila has confirmed the date."). The confirm button repeats the word of the
// button that was pressed — "Cancel request" — so the modal never introduces
// a verb of its own. The markup is shared/_confirm_modal, in the layouts;
// without it we fall back to the browser's confirm rather than block a form.
const ID = "confirm-modal"

function ask(message, _element, submitter) {
  const modal = document.getElementById(ID)
  if (!modal) return Promise.resolve(window.confirm(message))

  const [ question, ...rest ] = String(message).split(/(?<=\?)\s+/)
  const body = modal.querySelector("[data-confirm-body]")
  modal.querySelector("[data-confirm-title]").textContent = question
  body.textContent = rest.join(" ")
  body.hidden = rest.length === 0

  const ok = modal.querySelector("[data-confirm-ok]")
  ok.textContent = submitter?.textContent?.trim() || "Confirm"

  window.openModal(ID)
  return new Promise((resolve) => {
    // One controller for every listener: answering removes them all, so a
    // second confirm starts clean.
    const listeners = new AbortController()
    const settle = (answer) => {
      listeners.abort()
      window.closeModal(ID)
      resolve(answer)
    }
    const on = (target, event, fn) => target.addEventListener(event, fn, { signal: listeners.signal })

    on(ok, "click", () => settle(true))
    modal.querySelectorAll("[data-confirm-no]").forEach((el) => on(el, "click", () => settle(false)))
    on(modal, "click", (event) => { if (event.target === modal) settle(false) })
    on(document, "keydown", (event) => { if (event.key === "Escape") settle(false) })
  })
}

// Turbo 8 moved the hook to config.forms.confirm; setConfirmMethod is still
// there and still works, so set whichever this version has.
if (Turbo.config?.forms) Turbo.config.forms.confirm = ask
else Turbo.setConfirmMethod(ask)
